import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import styles from "./Button.module.scss"

const Button = ({
  primary = true,
  outline = false,
  link = false,
  children,
  onClick,
  className = "",
  disabled = false,
  loading = false,
  type = "button"
}) => {
  const buttonClasses = classNames(
    "btn",
    {
      "btn-primary": primary && !outline && !link,
      "btn-outline-primary": outline,
      "btn-link": link
    },
    styles.Button,
    className
  )

  return (
    <button
      type={type === "submit" ? "submit" : "button"}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  primary: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.string,
  outline: PropTypes.bool,
  link: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default Button
